import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useContext } from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useThemeProps, TableCell } from '@mui/material';
import TableContext from '../TableContext.js';
import TableColumnContent from './TableColumnContent.js';
import TableColumnFallback from './TableColumnFallback.js';
import RowLinkCell from '../cells/RowLinkCell.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var componentRoot = createComponentSlot({
  name: "CinTableColumn",
  slot: "Root",
  skipForwardProps: ["headerExists"]
});

var TableColumnBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TableColumnBase, _React$Component);

  var _super = _createSuper(TableColumnBase);

  function TableColumnBase() {
    var _this;

    _classCallCheck(this, TableColumnBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_renderWarning", false);

    return _this;
  }

  _createClass(TableColumnBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          field = _this$props.field,
          title = _this$props.title,
          _this$props$fallback = _this$props.fallback,
          fallback = _this$props$fallback === void 0 ? null : _this$props$fallback,
          header = _this$props.header,
          footer = _this$props.footer,
          component = _this$props.component,
          render = _this$props.render,
          align = _this$props.align,
          span = _this$props.span,
          hoverable = _this$props.hoverable,
          noRowClick = _this$props.noRowClick,
          noRowLink = _this$props.noRowLink,
          className = _this$props.className;
      var _this$context = this.context,
          item = _this$context.item,
          itemKey = _this$context.itemKey,
          itemIndex = _this$context.itemIndex,
          expanded = _this$context.expanded,
          headerRow = _this$context.headerRow,
          footerRow = _this$context.footerRow,
          onClick = _this$context.onClick,
          onExpand = _this$context.onExpand,
          onCollapse = _this$context.onCollapse,
          renderRowLink = _this$context.renderRowLink;

      if (headerRow) {
        // render header cell
        return /*#__PURE__*/React.createElement(TableCell, {
          align: align,
          className: classnames(componentRoot.className, className),
          colSpan: span
        }, header || title);
      }

      if (footerRow) {
        // render footer cell
        return /*#__PURE__*/React.createElement(TableCell, {
          align: align,
          className: classnames(componentRoot.className, className),
          colSpan: span
        }, footer);
      }

      var Component = component;
      var cellState = {
        itemKey: itemKey,
        itemIndex: itemIndex,
        expanded: expanded
      };
      var cellEvents = {
        onExpand: onExpand,
        onCollapse: onCollapse
      };
      var cellStyle = {
        cursor: onClick && !noRowClick ? "pointer" : undefined
      };

      if (render && Component && !this._renderWarning) {
        this._renderWarning = true;
        console.warn("Table Column should be passed either render or component prop, not both");
      }

      var cellContent = !item ? null : render ? render(item, cellState, cellEvents) : Component ? /*#__PURE__*/React.createElement(Component, _extends({
        item: item
      }, cellState, cellEvents)) : field !== undefined ? item[field] : null; // scenarios where the fallback will definitely not be shown
      // otherwise it may be required depending on whether children renders any DOM elements

      var fallbackNotRequired = fallback === null || typeof cellContent === "number" || typeof cellContent === "string" && cellContent.trim() !== "";

      if (!fallbackNotRequired) {
        cellContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableColumnContent, null, cellContent), /*#__PURE__*/React.createElement(TableColumnFallback, null, fallback));
      } // render data cell with content wrapped in custom link


      if (renderRowLink && item && !noRowLink) {
        var rowLink = renderRowLink(item);
        cellContent = /*#__PURE__*/React.cloneElement(rowLink, _objectSpread2(_objectSpread2({}, rowLink.props), {}, {
          children: /*#__PURE__*/React.createElement(RowLinkCell, null, cellContent)
        }));
        cellStyle = _objectSpread2(_objectSpread2({}, cellStyle), {}, {
          padding: 0
        });
      } // render data cell


      return /*#__PURE__*/React.createElement(TableCell, {
        align: align,
        className: classnames(componentRoot.className, {
          hoverable: hoverable
        }, className),
        style: cellStyle,
        colSpan: span,
        onClick: noRowClick ? function (e) {
          return e.stopPropagation();
        } : undefined
      }, cellContent);
    }
  }]);

  return TableColumnBase;
}(React.Component);

_defineProperty(TableColumnBase, "propTypes", {
  field: propTypes.string,
  title: propTypes.node,
  fallback: propTypes.node,
  header: propTypes.node,
  footer: propTypes.node,
  component: propTypes.elementType,
  render: propTypes.func,
  width: propTypes.oneOfType([propTypes.string, propTypes.number]),
  span: propTypes.number,
  hoverable: propTypes.bool,
  noRowClick: propTypes.bool,
  noRowLink: propTypes.bool,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
});

_defineProperty(TableColumnBase, "contextType", TableContext);

var TableColumnRoot = styled(TableColumnBase, componentRoot.styledOptions)(function (_ref) {
  var width = _ref.width,
      headerExists = _ref.headerExists;
  return _objectSpread2({}, headerExists === false ? {
    "&.MuiTableCell-body": {
      width: width
    }
  } : {
    "&.MuiTableCell-head": {
      width: width
    }
  });
});
/**
 * Renders a standard column for a table data item
 */

var TableColumn = function TableColumn(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });

  var _useContext = useContext(TableContext),
      headerExists = _useContext.headerExists;

  return /*#__PURE__*/React.createElement(TableColumnRoot, _extends({}, rootProps, {
    headerExists: headerExists
  }));
};

var TableColumn$1 = TableColumn;

export { TableColumn$1 as default };
